// NewUserForm.js
import axios from "axios";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UserAccessChange = (prop) => {
  const InitState = {
    username: null,
    userRights: null,
    activeStatus: null,
    user: prop.username,
  };
  const [formData, setFormData] = useState(InitState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSelectChange = (e) => {
    console.error(e);
    const selectedIndex = UserDetails.findIndex((item) => item.Username === e);
    //console.log(UserDetails[selectedIndex])
    const Username = UserDetails[selectedIndex].Username;
    const Rights = UserDetails[selectedIndex].Rights;
    const ActiveStatus = UserDetails[selectedIndex].Active_Status;
    setFormData({
      ...formData,
      username: Username,
      userRights: Rights,
      activeStatus: ActiveStatus,
    });
  };
  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const [UserDetails, SetUserDetails] = useState([]);
  const fetchUserDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/user/FetchUserList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetUserDetails(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/user/UserAccessChange`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
            fetchUserDetails();
          }
          if (res.status === 201) {
            WarningMSG(res.data.message);
            fetchUserDetails();
          }
          fetchUserDetails();
          formData([]);
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });

      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    setFormData(InitState);
  };
  return (
    <div className="FormContainer">
      <ToastContainer />
      <h2 className="UserManagementFormHeadLabel">User Access Change</h2>
      <form className="UserManagementForm" onSubmit={handleSubmit}>
        <label className="UserManagementPageFormLables">Username </label>
        <select
          className="UserManagementPageFormInputs"
          value={formData.username}
          onChange={(e) => handleSelectChange(e.target.value)}
          required
          id="username"
          name="username"
        >
          <option value="">Select</option>
          {UserDetails.map((items) => {
            return <option value={items.Username}>{items.Username}</option>;
          })}
        </select>
        <br />
        <label className="UserManagementPageFormLables">User Rights</label>
        <select
          className="UserManagementPageFormInputs"
          value={formData.userRights}
          onChange={handleChange}
          required
          id="userRights"
          name="userRights"
        >
          <option value="">Select</option>
          <option value="E">Executive User</option>
          <option value="A">Admin User</option>
        </select>
        <br />
        <label className="UserManagementPageFormLables">Active Status</label>
        <select
          className="UserManagementPageFormInputs"
          value={formData.activeStatus}
          onChange={handleChange}
          required
          id="status"
          name="activeStatus"
        >
          <option value="">Select</option>
          <option value="YES">Active</option>
          <option value="NO">Inactive</option>
        </select>
        <br />
        <button
          className="UserManagementPageFormSumbit"
          title="Submit"
          type="submit"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default UserAccessChange;
